import { render, staticRenderFns } from "./PaymentBadge.vue?vue&type=template&id=9f5b8ed8&scoped=true&lang=pug&"
import script from "./PaymentBadge.vue?vue&type=script&lang=ts&"
export * from "./PaymentBadge.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentBadge.vue?vue&type=style&index=0&id=9f5b8ed8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5b8ed8",
  null
  
)

export default component.exports